<template>
  <form @submit.prevent="submitAction" class="grid gap-4">
    <ValidationProvider rules="required" name="content" tag="div" vid="content">
      <template #default="{ errors }">
        <BaseFormGroup class="md:w-2/3 lg:w-1/2">
          <BaseFormLabel>Content</BaseFormLabel>
          <BaseFormTextarea v-model="computedContent" rows="3" :disabled="disabled" />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <div class="grid grid-flow-col gap-2 justify-start">
      <BaseButton primary :disabled="disabled || invalid"> Save </BaseButton>

      <BaseButton type="button" secondary :disabled="disabled" @click="$emit('cancel')">
        Cancel
      </BaseButton>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: '',
    },
    invalid: Boolean,
    disabled: Boolean,
  },

  computed: {
    computedContent: {
      get() {
        return this.content;
      },
      set(value) {
        this.$emit('update:content', value);
      },
    },
  },

  methods: {
    submitAction() {
      this.$emit('submit');
    },
  },
};
</script>
